import React from 'react';
import "./t&c.css";
import logo from "../../assets/images/logo.png";

function TermsAndConditions() {
    return (
        <div className="tc-page">
            <div className="tc-container">
                <div className="tc-console">
                    <img className="tc-console-img" src={logo} alt="Hymus Sports Logo" />
                    <h1 className="tc-console-header">Terms & Conditions</h1>

                    <div className="tc-console-body">
                        <div className="terms-content">
                            <div className="terms-section">
                                <p className="last-updated">Last Updated: May 25, 2026</p>
                            </div>

                            <div className="terms-section">
                                <h2>1. Booking Terms</h2>
                                <p className="section-intro">
                                    By making a court booking at Hymus Sports, you agree to the following terms:
                                </p>
                                <div className="terms-list">
                                    • Court bookings are subject to availability<br />
                                    • Specific court requests cannot be guaranteed<br />
                                    • Court assignments are at management's discretion<br />
                                    • Court time starts and ends at scheduled times
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>2. Privacy & Data Collection</h2>
                                <p className="section-intro">We collect the following information:</p>
                                <div className="terms-list">
                                    • Name (required)<br />
                                    • Email address (required)<br />
                                    • Phone number (optional but recommended)
                                </div>
                                <p className="section-subtitle">Your personal information is:</p>
                                <div className="terms-list">
                                    • Used solely for booking management<br />
                                    • Never shared with third parties<br />
                                    • Stored securely in our system<br />
                                    • Only accessible by authorized staff
                                </div>
                                <p className="section-subtitle">
                                    You may request access to or deletion of your information by contacting us (see Section 8).
                                </p>
                            </div>

                            <div className="terms-section">
                                <h2>3. Cancellation Policy</h2>
                                <div className="terms-list">
                                    • Cancellations required 3 hours in advance<br />
                                    • Late cancellations may incur fees<br />
                                    • Bookings will be marked as no-shows 20 minutes after the scheduled start time<br />
                                    • No-shows charged full booking amount<br />
                                    • Refunds, if issued, are at management's discretion<br />
                                    • Contact us by phone or email to cancel, or use the link in your confirmation email
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>4. Court Rules</h2>
                                <div className="terms-list">
                                    • Proper sports attire required<br />
                                    • Non-marking shoes mandatory<br />
                                    • Respect other players and staff<br />
                                    • Keep courts clean and tidy<br />
                                    • Damage to facilities or equipment may result in repair/replacement charges
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>5. Payment & Rates</h2>
                                <div className="terms-list">
                                    • Rates subject to change without notice<br />
                                    • Payment due at time of play unless otherwise arranged<br />
                                    • All prices in Canadian Dollars (CAD), exclusive of applicable taxes
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>6. Liability</h2>
                                <p className="section-intro">By using our facilities, you acknowledge that:</p>
                                <div className="terms-list">
                                    • Sports activities carry inherent risks of injury<br />
                                    • You participate at your own risk<br />
                                    • Hymus Sports is not liable for injuries or lost items<br />
                                    • You agree to follow safety guidelines and staff instructions<br />
                                    • Minors must be supervised by a parent or guardian
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>7. Refusal of Service</h2>
                                <div className="terms-list">
                                    • We reserve the right to refuse service or block bookings for repeated no-shows, abusive behavior, or violation of these terms<br />
                                    • Blocked email addresses or phone numbers may be prevented from booking
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>8. Contact & Governing Law</h2>
                                <div className="terms-list">
                                    • Email: hymussports11@gmail.com<br />
                                    • Business: Hymus Sports, Ontario, Canada<br />
                                    • These terms are governed by the laws of the Province of Ontario, Canada
                                </div>
                            </div>

                            <div className="terms-section">
                                <h2>9. Changes to Terms</h2>
                                <div className="terms-list">
                                    • These terms and conditions are subject to change without notice<br />
                                    • The "Last Updated" date reflects the most recent revision<br />
                                    • Continued use of our facilities constitutes acceptance of any changes
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditions;